/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import _ from 'lodash';
import { useDropzone } from 'react-dropzone';
import { Delete } from '@mui/icons-material';
import { ArrowBack } from '@material-ui/icons';
import { formatDate } from './commentsAndNotes.component';
import { getAllClientComments, postClientComment, updateClientComment, postClientCommentsAttachment, updateClientCommentsAttachment, deleteClientCommentsAttachment } from 'modules/clients/clients.actions';
import { UPDATE_CLIENT_COMMENT_FAILURE, UPDATE_CLIENT_COMMENTS_ATTACHMENT_FAILURE, DELETE_CLIENT_COMMENTS_ATTACHMENT_FAILURE, GET_CLIENT_COMMENTS_FAILURE } from 'modules/clients/types';
import AttachmentsUpload from 'modules/common/attachments/attachmentsUpload.component';
import SpinnerComponent from 'modules/common/spinner.component';


const SelectedCommentAndNote = props => {
  const {
    selectedComment,
    commentsAndNotesWithAttachments,
    setIsLoading,
    isNewComment,
    setSelectedComment,
    halfView,
    enumerations,
    clientRecordId,
    details,
    setFilteredRows,
    internalUsers
  } = props;

  const serviceOptions = enumerations?.allEnums?.authCommentService.filter(c => c.enumType === 2) || [];
  const regardingOptions = enumerations?.allEnums?.authCommentRegarding.filter(c => c.enumType === 2) || [];
  const categoryOptions = details?.clientDetails?.clientRelocationPolicies.map((p) => {
    return { id: p.relocationPolicyId, title: p.policyDescription}
  }) || [];

  const internalUserTypes =
    props.internalUserTypesEnum && props.internalUserTypesEnum.length > 0
      ? props.internalUserTypesEnum.filter(s => s.isActive === true)
      : [];

  const internalUsersMapping = [];
  if (internalUsers) {
    internalUsers.map((iu) => {
      const internalUserType = internalUserTypes.find((iut) => iut.id === iu.internalUserTypeId)?.title;
      internalUsersMapping.push({
        title: `${iu.firstName} ${iu.lastName} (${internalUserType})`,
        id: iu.internalUserId
      })
    })
  }

  const [open, setOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [temporaryAttachments, setTemporaryAttachments] = useState([]);
  const [isCancelButtonDisabled, setIsCancelButtonDisabled] = useState(true);
  const [isSubmitDisable, setIsSubmitDisable] = useState(true);
  const [lockScreen, setLockScreen] = useState(selectedComment || isNewComment ? false : true);
  const [commentFormData, setCommentFormData] = useState(selectedComment);
  const [isUploading, setIsUploading] = useState(false);

  const checkRequiredValues = () => {
    if (
      commentFormData &&
      commentFormData?.regardingId &&
      commentFormData?.serviceId &&
      commentFormData?.subject &&
      commentFormData?.subject !== '' &&
      commentFormData?.comment &&
      commentFormData?.comment !== ''
    ) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (isFormDirty()) {
      setIsCancelButtonDisabled(false);

      if (checkRequiredValues()) {
        setIsSubmitDisable(false);
      } else {
        setIsSubmitDisable(true);
      }
    } else {
      if (isNewComment && checkRequiredValues()) {
        setIsSubmitDisable(false);
      } else {
        setIsSubmitDisable(true);
      }
      if (halfView && isNewComment) {
        setIsCancelButtonDisabled(false);
      } else {
        setIsCancelButtonDisabled(true);
      }
    }
  }, [commentFormData, selectedComment, isNewComment]);

  useEffect(() => {
    setCommentFormData({ ...selectedComment });
    if (selectedComment || isNewComment) {
      setLockScreen(false);
    } else {
      setLockScreen(true);
    }
  }, [selectedComment, isNewComment]);

  const handleClose = () => {
    setTemporaryAttachments([]);
    setOpen(false);
  };

  const onDrop = acceptedFiles => {
    setTemporaryAttachments([...temporaryAttachments, ...acceptedFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleRemoveAttachment = index => {
    setAttachments(attachments.filter((_, i) => i !== index));
  };

  const isFormDirty = () => {
    return !_.isEqual(commentFormData, selectedComment);
  };

  const handleSaveFile = () => {
    setAttachments([...attachments, ...temporaryAttachments]);
    handleClose();
  };

  const cancelComment = () => {
    if (halfView && isNewComment) {
      setCommentFormData(null);
      setSelectedComment(null);
    } else {
      setCommentFormData(selectedComment);
    }
  };

  const updateComment = async () => {
    setIsLoading(true);
    var comment = {
        clientCommentId: selectedComment.clientCommentId,
        clientRecordId: clientRecordId,
        commentId: selectedComment.commentId,
        serviceId: commentFormData.serviceId,
        regardingId: commentFormData.regardingId,
        subject: commentFormData.subject,
        comment: commentFormData.comment,
        addedBy: commentFormData.addedBy,
        addedOn: commentFormData.addedOn,
        modifiedBy: commentFormData.modifiedBy,
        modifiedOn: commentFormData.modifiedOn
    }
    const resp = await props.updateClientComment(comment);

    if (resp.type === UPDATE_CLIENT_COMMENT_FAILURE) {
      props.showToast('Failed to update comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      const updated = resp.response.find(c => c.info.clientCommentId === selectedComment.clientCommentId);
      if (updated) {
        setSelectedComment(updated.info);
      }
      setFilteredRows(resp.response.map((n) => { return n.info }));
    }

    setIsLoading(false);
  };

  const handleRegardingValueChange = value => {
    setCommentFormData({ ...commentFormData, regardingId: value });
  };
  
    const convertToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file); 
  
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
  
        fileReader.onerror = (error) => {
          reject(error);
        };
      });
    };
  
    const saveFiles = async (filesToSave) => {  
      setIsUploading(true);
      try {
        // Ensure comment data doesn't cleared when saving attachments
        await updateComment();

        const allPromises = filesToSave.map(async (file) => {
          setIsUploading(true);

          var base64 = await convertToBase64(file);
  
          base64 = base64.split(',')[1]; // Remove the data:<contentType>;base64, part
  
          await props.postClientCommentsAttachment({
            base64FileData: base64,
            fileName: file.name,
            contentType: file.type
          }, clientRecordId, selectedComment.commentId);
        });
  
        await Promise.all(allPromises);
  
        props.showToast('Successfully uploaded attachments', TOAST_MESSAGE_SEVERITY_SUCCESS);
      } catch (error) {
        console.error("Error uploading files:", error);
        props.showToast('Failed to upload attachments, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      } finally {
        const commentsResp = await props.getAllClientComments(clientRecordId);
        if(commentsResp.type === GET_CLIENT_COMMENTS_FAILURE) {
            props.showToast('Failed to retrieve client comments, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
        }
      }
      setIsUploading(false);
    }
  
    const updateFile = async (file) => {
      setIsUploading(true);
      const updateFileResp = await props.updateClientCommentsAttachment(file, clientRecordId, selectedComment.commentId);
      if (updateFileResp.type === UPDATE_CLIENT_COMMENTS_ATTACHMENT_FAILURE) {
        props.showToast('Failed to update attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      } else {
        props.showToast('Successfully updated attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
        const commentsResp = await props.getAllClientComments(clientRecordId);
        if(commentsResp.type === GET_CLIENT_COMMENTS_FAILURE) {
            props.showToast('Failed to retrieve client comments, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
        }
      }
      setIsUploading(false);
    };
  
    const deleteFile = async (file) => {
      setIsUploading(true);
      const deleteFileResp = await props.deleteClientCommentsAttachment(clientRecordId, selectedComment.commentId, file.attachmentId);
      if (deleteFileResp.type === DELETE_CLIENT_COMMENTS_ATTACHMENT_FAILURE) {
        props.showToast('Failed to delete attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      } else {
        props.showToast('Successfully deleted attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
        const commentsResp = await props.getAllClientComments(clientRecordId);
        if(commentsResp.type === GET_CLIENT_COMMENTS_FAILURE) {
            props.showToast('Failed to retrieve client comments, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR })
        }
      }
      setIsUploading(false);
    };

  return (
    <Paper
      square
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '10px',
        backgroundColor: 'transparent',
        paddingLeft: '5px',
        paddingRight: '5px',
        border: 'none',
        borderLeft: '1px solid #ccc',
        boxShadow: 'none'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '90vh',
          pointerEvents: lockScreen ? 'none' : 'auto',
          opacity: lockScreen ? 0.5 : 1
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Paper
              square
              sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'transparent',
                padding: '16px',
                border: 'none',
                borderBottom: '1px solid #ccc',
                boxShadow: 'none'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: '20px'
                }}
              >
                {halfView && !isNewComment && (
                  <Box
                    textAlign="center"
                    sx={{
                      marginBottom: '16px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <IconButton
                      onClick={() => setSelectedComment(null)}
                      sx={{
                        backgroundColor: '#f5f5f5',
                        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
                        '&:hover': {
                          backgroundColor: '#e0e0e0'
                        },
                        color: '#43423a'
                      }}
                      aria-label="back"
                    >
                      <ArrowBack />
                    </IconButton>
                  </Box>
                )}
                <Box textAlign="center">
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                    Added By
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                    {internalUsersMapping.find((c) => c.id === commentFormData?.addedBy)?.title || ''}
                  </Typography>
                </Box>
                <Box textAlign="center">
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                    Modified By
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                    {internalUsersMapping.find((c) => c.id === commentFormData?.modifiedBy)?.title || ''}
                  </Typography>
                </Box>
                <Box textAlign="center">
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                    Created Date
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                    {formatDate(commentFormData?.addedOn)}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Box>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'serviceSelector'}>
                    Service
                  </InputLabel>
                  <Select
                    labelId={'serviceSelector'}
                    key={'serviceSelector'}
                    label={'Service'}
                    name={'service'}
                    required={true}
                    value={commentFormData?.serviceId || ''}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    onChange={e => setCommentFormData({ ...commentFormData, serviceId: e.target.value })}
                  >
                    {serviceOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'regardingSelector'}>
                    Regarding
                  </InputLabel>
                  <Select
                    labelId={'regardingSelector'}
                    key={'regardingSelector'}
                    label={'Regarding'}
                    name={'regarding'}
                    required={true}
                    value={commentFormData?.regardingId || ''}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    onChange={e => handleRegardingValueChange(e.target.value)}
                  >
                    {regardingOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box>
                <FormControl sx={{ marginTop: '6px' }}>
                  <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'regardingSelector'}>
                    Categorization
                  </InputLabel>
                  <Select
                    labelId={'regardingSelector'}
                    key={'regardingSelector'}
                    label={'Categorization'}
                    name={'categorization'}
                    required={true}
                    value={commentFormData?.categorizationId || ''}
                    disabled={commentFormData?.regardingId !== '1c233ca1-b164-4170-bc29-6f857bfe3319'}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                    onChange={e => setCommentFormData({ ...commentFormData, categorizationId: e.target.value })}
                  >
                    {categoryOptions.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <TextField
                  key={'subject'}
                  label={'Subject'}
                  name={'subject'}
                  required={true}
                  value={commentFormData?.subject || ''}
                  margin="dense"
                  multiline
                  variant="standard"
                  rows={1}
                  sx={{
                    width: '100%',
                    maxWidth: '600px',
                    minWidth: '200px'
                  }}
                  onChange={e => setCommentFormData({ ...commentFormData, subject: e.target.value })}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <TextField
                  label={'Comment'}
                  name={'commentContent'}
                  required={true}
                  value={commentFormData?.comment || ''}
                  margin="dense"
                  multiline
                  variant="standard"
                  rows={3}
                  fullWidth
                  sx={{
                    width: '100%',
                    maxWidth: '600px',
                    minWidth: '200px'
                  }}
                  onChange={e => setCommentFormData({ ...commentFormData, comment: e.target.value })}
                />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ padding: '8px' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '16px',
                  marginTop: '16px'
                }}
              >
                {attachments.map((attachment, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      backgroundColor: '#f9f9f9',
                      padding: '8px',
                      borderRadius: '4px',
                      maxWidth: 'calc(100% - 16px)'
                    }}
                  >
                    <Tooltip arrow placement="top" title="Delete">
                      <IconButton color="error" onClick={() => handleRemoveAttachment(index)}>
                        <Delete />
                      </IconButton>
                    </Tooltip>
                    <Link
                      href={attachment.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: '#007bff',
                        textDecoration: 'underline',
                        cursor: 'pointer'
                      }}
                    >
                      {attachment.name}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Grid>
        </Grid>
        <Grid item xs={12} sx={{ padding: '8px' }}>
          {isUploading && <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
            <Typography variant="subtitle1">Updating Attachments...</Typography>
            <SpinnerComponent/>
          </Box>}

          <AttachmentsUpload 
            saveFiles={saveFiles}
            fileAttachments={selectedComment && selectedComment.commentId && commentsAndNotesWithAttachments ? commentsAndNotesWithAttachments.find(c => c.info.commentId === selectedComment.commentId)?.attachments : []}
            isUploading={isUploading}
            updateFile={updateFile}
            deleteFile={deleteFile}
            webViewableText={'Web Viewable'}
            descriptionText={'Description'}
          />
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '16px' }}>
          <Button
            color="secondary"
            variant="contained"
            sx={{
              maxHeight: '40px',
              marginLeft: '12px',
              marginTop: '8px',
              backgroundColor: '#868686',
              '&:hover': { backgroundColor: '#474747' }
            }}
            disabled={isCancelButtonDisabled}
            onClick={cancelComment}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              maxHeight: '40px',
              marginLeft: '12px',
              marginTop: '8px',
              backgroundColor: '#67A783',
              '&:hover': {
                backgroundColor: '#53936F'
              },
              color: '#FFFFFF'
            }}
            disabled={isSubmitDisable}
            onClick={updateComment}
          >
            {'Save Comment'}
          </Button>
        </Box>
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <DialogTitle>Upload Attachments</DialogTitle>
          <DialogContent>
            <Box
              {...getRootProps()}
              sx={{
                border: '2px dashed gray',
                borderRadius: '8px',
                padding: '16px',
                textAlign: 'center',
                cursor: 'pointer',
                marginBottom: '16px'
              }}
            >
              <input {...getInputProps()} />
              <Typography>Drag & drop files here, or click to select files</Typography>
            </Box>
            <Box>
              {temporaryAttachments.length > 0 ? (
                temporaryAttachments.map((file, index) => <Typography key={index}>{file.name}</Typography>)
              ) : (
                <Typography>No files uploaded</Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              color="secondary"
              variant="text"
              sx={{
                color: '#868686',
                '&:hover': {
                  color: '#474747',
                  backgroundColor: 'transparent'
                }
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleSaveFile} color="primary">
              Submit File
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Paper>
  );
};

const mapStateToProps = state => ({});

export default compose(connect(mapStateToProps, { postClientComment, updateClientComment, postClientCommentsAttachment, updateClientCommentsAttachment, deleteClientCommentsAttachment, getAllClientComments, showToast }))(
  SelectedCommentAndNote
);
